export const translateFilterKeys = (string, currentLanguage = "EN") => {
  switch (string) {
    case "ticket_status":
      return currentLanguage === "EN"
        ? "Status"
        : currentLanguage === "IT"
        ? "Stato"
        : "Status";
    case "project_status":
      return currentLanguage === "EN"
        ? "Status"
        : currentLanguage === "IT"
        ? "Stato"
        : "Status";
    case "category":
      return currentLanguage === "EN"
        ? "Category"
        : currentLanguage === "IT"
        ? "Categoria"
        : "Category";
    case "company_name":
      return currentLanguage === "EN"
        ? "Company Name"
        : currentLanguage === "IT"
        ? "Ragione Sociale"
        : "Company Name";
    case "updated_at":
      return currentLanguage === "EN"
        ? "Updated At"
        : currentLanguage === "IT"
        ? "Modificato il"
        : "Updated At";
    case "modified_at":
      return currentLanguage === "EN"
        ? "Updated At"
        : currentLanguage === "IT"
        ? "Modificato il"
        : "Updated At";
    case "created_at":
      return currentLanguage === "EN"
        ? "Created At"
        : currentLanguage === "IT"
        ? "Creato il"
        : "Created At";
    case "brand":
      return currentLanguage === "EN"
        ? "Brand"
        : currentLanguage === "IT"
        ? "Marca"
        : "Brand";
    case "model":
      return currentLanguage === "EN"
        ? "Model"
        : currentLanguage === "IT"
        ? "Modello"
        : "Model";
    case "vehicle_type":
      return currentLanguage === "EN"
        ? "Vehicle"
        : currentLanguage === "IT"
        ? "Veicolo"
        : "Vehicle";
    case "technical":
      return currentLanguage === "EN"
        ? "Technical"
        : currentLanguage === "IT"
        ? "Tecnico"
        : "Technical";
    case "administrative":
      return currentLanguage === "EN"
        ? "Administrative"
        : currentLanguage === "IT"
        ? "Amministrativo"
        : "Administrative";
    case "billing":
      return currentLanguage === "EN"
        ? "Billing"
        : currentLanguage === "IT"
        ? "Fatturazione"
        : "Billing";

    default:
      return string.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }
};
